import React from "react";

import { useUtilitiesContext } from "../../../contexts/UtilitiesContext";
import { useGetDeviceQuery } from "../api/Get";

export default function useGetDeviceHook() {
    const { showNotification } = useUtilitiesContext();

    const {
        data: devices = [],
        isError: isDevicesError,
        error: devicesError,
        isFetching: isDevicesFetching,
        refetch: refetchDevices
    } = useGetDeviceQuery();

    React.useEffect(() => {
        if (isDevicesError) {
            showNotification({
                type: "error",
                title: "Error",
                message: devicesError.message,
            });
        }
    }, [isDevicesError, devicesError, showNotification]);

    return {
        devices,
        isDevicesFetching,
        refetchDevices
    }
}